// extracted by mini-css-extract-plugin
export default {"slide":"App_slide__oSV16","slidePromo":"App_slidePromo__-jue3","slideShow":"App_slideShow__67m76","slideHide":"App_slideHide__KTAt8"};